<template>
	<div class="settings-panel">
		<SidebarHeader class="settings-panel-header"><template #title>Settings</template></SidebarHeader>

		<div class="settings-panel-content">
			<div class="settings-panel__section">
				<h4>My Profile</h4>
				<settings-item class="settings-panel__profile" @click="vm['sidebar/open']('profile')" :name="`${userName} ${userPronouns ? `(${userPronouns})` : ''}`" :disabled="isExternalGuest || !email" >
					<UserIcon class="settings-panel__user-icon" :currentUser="true"/>
				</settings-item>
				<div class="guest-register" v-if="isExternalGuest || !email">
					<span>You are currently using a guest account</span>
					<btn @click="() => registerAsGuestHandler()" rounded wide large colour="yellow">
						<template #text>
							<b>Signup to SPACEIN</b>
						</template>
					</btn>
				</div>
			</div>

			<div class="settings-panel__section" v-for="section in filteredMenuSections" :key="section.id">
				<h4>
					{{section.name.toLowerCase()}}
				</h4>
				<settings-item
					v-for="child in section.children"
					:key="child.id"
					v-bind="child"
				/>
			</div>

			<div class="settings-panel__section">
				<h4>Information</h4>
				<settings-item link='https://www.spacein.co.uk/terms-and-conditions' name='Terms and Conditions'/>
				<settings-item link='https://www.spacein.co.uk/privacy-policy' name='Privacy Policy'/>
				<settings-item link='https://www.spacein.co.uk/cookies-policy' name='Cookies Policy'/>
				<settings-item v-if="currentAreaId" @click="vm['tour/updateHandler'](true)" name='Step by Step guide'/>
				<settings-item @click="vm['checkDesktopNotifications'](true)" name='Check Desktop Notifications'/>
			</div>

			<div class="settings-panel__bottom">
				<button class="settings-panel__logout" @click="onLogout">Logout</button>
				<div class="settings-panel__version">SPACEIN v{{ appVersion }}</div>
			</div>
		</div>

	</div>
</template>

<script>
import SidebarHeader from '../SidebarHeader.vue';
import SettingsItem from './SettingsItem.vue'
import UserIcon from '../../UserIcon.vue';

import { mapGetters, mapActions } from 'vuex';

const permissionLevels = {'all': 0, 'admin': 1, 'super-admin': 2, 'suspended-user': -1};

export default {
	components: { SettingsItem, UserIcon, SidebarHeader },
	computed: {
		...mapGetters({
			userLevel: 'current_user/currentAreaPermissionNo',
			menuSections: 'root/menuItems',
			appVersion: 'root/version',
			userName: 'current_user/fullName',
			userPronouns: 'current_user/pronouns',
			email: 'current_user/email',
			currentAreaId: 'getCurrentAreaId',
			isExternalGuest: 'current_user/isExternalGuest',
		}),
		filteredMenuSections: vm => vm.menuSections.filter(
			x => permissionLevels[x.visibility] <= vm.userLevel
		),
		vm: vm => vm
	},
	methods: {
		...mapActions(['tour/updateHandler', 'sidebar/open', 'checkDesktopNotifications']),
		...mapActions('guest', ['registerAsGuestHandler']),
		...mapActions('api/auth', ['logout']),
		async onLogout() {[
			await this.logout()
		]}
	}
}
</script>

<style lang="scss" scoped>
.settings-panel {
	line-height: 1;
	font-size: 14px;
	color: white;
	font-weight: bold;
	display: flex;
	flex-flow: column;

	&-content {
		padding: 20px;
		display: flex;
		flex-flow: column;
		flex-grow: 1;
		overflow-y: auto;
	}

	&__profile {
		margin-top: 15px !important;
	}

	&__user-icon {
		height: 44px;
		width: 44px;
		box-sizing: border-box;
		margin-right: 10px;
	}

	& .guest-register {
		margin-top: 15px;
		background-color: $grey-6;
		padding: 20px;
		border-radius: 17px;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		font-weight: normal;
		font-size: 90%;
		color: $grey-3;
		text-align: center;
	}

	h4 {
		text-transform: capitalize;
	}

	&__section:not(:first-of-type) {
		h4 {
			margin-top: 40px;
		}
	}

	&__bottom {
		margin-top: auto;
		display: flex;
		flex-direction: column;
		gap: 25px;
		padding-top: 45px;
	}

	&__logout {
		background: $red;
		color: white;
		border-radius: 50px;
		border: 0;
		box-sizing: border-box;
		display: block;
		padding: 15px;
		font-size: 1rem;
		width: 100%;
		cursor: pointer;
		font-weight: bold;
	}

	&__version {
		opacity: 0.75;
		font-weight: normal;
	}
}
</style>
